import React, { PureComponent } from 'react'
import { Breadcrumb, Button, Popup } from 'semantic-ui-react'
import { Link, Redirect} from 'react-router-dom'
import { logout, showApiKey, isAuthenticated } from '../../services/self'
import { getApi } from '../../services/api-catalog'
import logo from '../../logo.png'
import SignIn from '../SignIn'
import Register from '../Register'

export default class Head extends PureComponent {
  constructor(props) {
    super(props)

    if (this.isApiDetailsRoute()) {
      getApi(props.match.params.apiId)
      .then(api => {
        this.setState({
          apiName: api.swagger.info.title
        })
      })
    }

    this.state = {
      isAuthenticated: isAuthenticated(),
      apiKey: ''
    }
  }

  isHomeRoute() {
    return this.props.pattern === '/'
  }

  isGettingStartedRoute() {
    return this.props.pattern === '/getting-started'
  }

  isCaseStudiesRoute() {
    return this.props.pattern === '/case-studies'
  }

  isApisListRoute() {
    return this.props.pattern === '/apis'
  }

  isApiDetailsRoute() {
    return this.props.pattern === '/apis/:apiId'
  }

  logout() {
    logout()
    this.setState({ loggedOut: true })
  }

  showApiKey() {
    showApiKey().then(apiKey => {
      this.setState({ apiKey })
    })
  }

  render() {
    return this.state.loggedOut ? <Redirect to='/' /> : (
      <section style={{marginBottom: '1rem'}}>
      <div className="App-header">
        <Link to="/"><img src={logo} className="App-logo" alt="logo" /></Link>
        <div className="captionText relativePosition">for developers</div>
        { this.state.isAuthenticated ?
          <div className="relativePosition">
            <div className="signInBtnPosition">
              <Button onClick={() => this.logout()} className="signInBtn">LOG OUT</Button>
            </div>
            <div className="registerBtnPosition">
              <Popup style={{fontSize:"15px"}}
                trigger={<Button onClick={() => this.showApiKey()} className="registerBtn">MY API KEY</Button>}
                content={this.state.apiKey ? this.state.apiKey.toString() : 'Loading API Key...'}
                on='click'
                positioning='bottom right'
              />
            </div>
            <div className="apisBtnPosition">
              <Link to='/apis'><Button className="apisBtn">APIs</Button></Link>
            </div>
            <div className="docsBtnPosition">
              <Link to='/documentation'><Button className="docsBtn">DOCUMENTATION</Button></Link>
            </div>
          </div> :
          <div className="relativePosition">
            <div className="signInBtnPosition">
              <SignIn usagePlanId={this.state.usagePlanId} token={this.state.token}/>
            </div>
            <div className="registerBtnPosition">
              <Register usagePlanId={this.state.usagePlanId} token={this.state.token} />
            </div>
            <div className="docsBtnPosition">
              <Link to='/documentation'><Button className="docsBtn">DOCUMENTATION</Button></Link>
            </div>
          </div>
        }
       </div>
      </section>)
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Head/index.js
 **/